import PageHeader from 'components/PageHeader';
import ListCreateButton from 'components/buttons/ListCreateButton';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import GroupsTableWithFilters from './GroupsTable';

const GroupsPage = (): JSX.Element => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'groups.groups'}
                    showBreadcrumb
                    buttons={
                        <div>
                            <ListCreateButton
                                permissions={['CREATE.PARTY_GROUPS']}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => navigateWithReturn(`/group/new`)}
                                labelId="groups.add-new-group"
                                newLabelId="new-entity.group"
                            />
                        </div>
                    }
                />
                <GroupsTableWithFilters />
            </div>
        </PaddedLayout>
    );
};

export default GroupsPage;
